// Module
var code = "You should return to the location you chose as a vantage point, where your view was wider, press ‘I’m there’ when you are. ";
// Exports
module.exports = code;